// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"27":"component---src-pages-storyblok-preview-jsx","256":"component---src-pages-404-jsx","855":"component---src-templates-page-jsx"}[chunkId] + "-" + {"27":"9d7010b08026a43ed813","256":"d72c309b617e87e729c3","855":"fb8f56d4876c30d519fb"}[chunkId] + ".js";
};